import actions from '../action/balance'
import CONSTANT from '../constant/balance'
import op from 'object-path'
export default {
  actions,
  state: {
    totalBalance: 0,
    balanceRecord: [/* {
      balanceAmount: 1,
      remainAmount: 1,//变动后的积分
      tradeSeq: '闵子横产擦歌词fhaskjdfhasdkfljhasd和深邃的地方地方撒撒地方撒的发送的法',
      // 积分变动类型：1:消费,2：回滚,3：退费 ,4：充值,5：提现
      type: 1,
      // UNIX TIME
      createdAt: 1534156465,
    } */],
    batchList: [],
  },
  getters: {

  },
  mutations: {
    cleanBalanceRecord(state, data) {
      return state.balanceRecord = []
    },
    [CONSTANT.BALANCE_GETBALANCERECORD_SUCCESS](state, data) {
      if (op(data).get('record')) {
        const newList = state.balanceRecord.concat(op(data).get('record'))
        newList.forEach(r =>  {
          r.isAdd = `${r.balanceAmount}`.indexOf('-') < 0
        })
        return state.balanceRecord = newList
      }
    },
    setBatchList(state, data) {
      return state.batchList = data
    },
    [CONSTANT.BALANCE_GETBALANCERECORD_ERROR](state, e) {

    },
    [CONSTANT.BALANCE_GETUSERBALANCE_SUCCESS](state, data) {
      return state.totalBalance = data.totalAmount
    },
    [CONSTANT.BALANCE_GETUSERBALANCE_ERROR](state, e) {

    },
    [CONSTANT.BALANCE_GETBALANCERECORDDETAIL_SUCCESS] (state, data) {

    },
    [CONSTANT.BALANCE_GETBALANCERECORDDETAIL_ERROR] (state, e) {
    },
    /*yeoman-template-point-1*/

  }
}
